import { apiHelper, getApiBaseUrl } from '../utils/apiHelper';

// const API_URL = `${process.env.REACT_APP_API_URL}/api/org/seo`;
const API_URL = `${getApiBaseUrl()}/api/org/seo`;
const API_URL1 = `${getApiBaseUrl()}/api/org/update-seo-data`;

export const fetchSeoContents = (payload) => apiHelper(API_URL, 'GET', payload);
export const updateSeoContents = (payload) => apiHelper(API_URL1, 'POST', payload);